<div class="p-6">
  <h2 class="text-xl font-semibold mb-4 text-white">{{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.TITLE' | translate
  }}</h2>

  <div class="mb-6">
    <p class="text-sm text-gray-300 mb-4">
      {{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.DESCRIPTION' | translate }}
    </p>

    <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.EMAILS_LABEL' | translate }}</mat-label>
      <textarea matInput [(ngModel)]="emailInput" rows="8">
      </textarea>
      <mat-hint>{{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.EMAILS_HINT' | translate }}</mat-hint>
    </mat-form-field>

    @if (emails.length > 0) {
      <div class="mb-4">
        <p class="text-sm font-semibold text-gray-300">
          {{ emails.length }} {{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.EMAILS_COUNT' | translate }}
        </p>
      </div>
    }

    <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.ENTITE_ID_LABEL' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="novoEntiteId">
      <mat-hint>{{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.ENTITE_ID_HINT' | translate }}</mat-hint>
    </mat-form-field>

    <div class="flex items-center gap-4">
      <button mat-raised-button (click)="deplacer()" [disabled]="isLoading || emails.length === 0 || !novoEntiteId"
        class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
        @if (!isLoading) {
          <mat-icon>move_group</mat-icon>
        }
        @if (isLoading) {
          <mat-spinner diameter="20" class="inline-block mr-2"></mat-spinner>
        }
        {{ 'ADMINISTRATION_AVANCEE.DEPLACER_UTILISATEURS.MOVE_BUTTON' | translate }}
      </button>
    </div>
  </div>
</div>